// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".47a4979406616e0ecbb78dd3ee40c65da04bf026.chunk.bundle.js";
};